import React from 'react';
import { settingsState } from '../../state';
import { useRecoilValue } from 'recoil';




export const FileCatalogList = ({ catalogs }) => {
    const { mainColor } = useRecoilValue(settingsState);
    return (
        <div className="text-center mt-4">
            {catalogs?.map((catalog, index) => (
                <div key={"fileToDownload" + index}>
                    <a
                        href={catalog.file.asset.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex font-semibold mb-4"
                        style={{ color: mainColor }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 mr-2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                        </svg>
                        {" "}
                        {catalog.title}
                    </a>
                </div>
            ))}
        </div>
    );
};
